"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDataPage = void 0;
var React = require("react");
var WidgetDataPage_styles_1 = require("./WidgetDataPage.styles");
var WidgetDataPage = /** @class */ (function (_super) {
    __extends(WidgetDataPage, _super);
    function WidgetDataPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMoveUp = function (index) {
            var _a;
            var items = _this.props.Cards;
            _a = [items[index - 1], items[index]], items[index] = _a[0], items[index - 1] = _a[1];
            _this.completeMove(items);
        };
        _this.handleMoveDown = function (index) {
            var _a;
            var items = _this.props.Cards;
            _a = [items[index + 1], items[index]], items[index] = _a[0], items[index + 1] = _a[1];
            _this.completeMove(items);
        };
        _this.completeMove = function (cards) {
            _this.forceUpdate();
            if (_this.props.OnCardReorder) {
                _this.props.OnCardReorder(cards);
            }
        };
        _this.handleDeleteClicked = function (index) {
            var cards = _this.props.Cards;
            cards.splice(index, 1);
            _this.completeMove(cards);
        };
        return _this;
    }
    WidgetDataPage.prototype.render = function () {
        var _this = this;
        return (React.createElement(WidgetDataPage_styles_1.UL, null, this.props.Cards.map(function (card, index) {
            return React.cloneElement(card, {
                IsBottommost: index === _this.props.Cards.length - 1,
                IsTopmost: index === 0,
                OnDeleteClicked: function () {
                    _this.handleDeleteClicked(index);
                },
                OnDownClick: function () {
                    _this.handleMoveDown(index);
                },
                OnUpClick: function () {
                    _this.handleMoveUp(index);
                },
            });
        })));
    };
    return WidgetDataPage;
}(React.PureComponent));
exports.WidgetDataPage = WidgetDataPage;
